export default "__VITE_ASSET__BcfiIZMt__"